import { render } from "./TdTransaction.vue?vue&type=template&id=46955d30"
import script from "./TdTransaction.vue?vue&type=script&lang=js"
export * from "./TdTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__